import { LOGO_URL } from '@generated/brand';

export function Logo({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  const h = size === 'lg' ? 'h-42' : size === 'sm' ? 'h-8' : 'h-[132px]';
  if (LOGO_URL) return <img src={LOGO_URL} alt="Sport Decisions Library" className={`${h} w-auto max-w-full object-contain`} />;
  return (
    <span className={`flex items-center gap-1.5 font-semibold tracking-tight text-secondary ${size === 'lg' ? 'text-xl' : 'text-base'}`}>
      <span className="h-2 w-2 rounded-full bg-primary" />
      Sport Decisions Library
    </span>
  );
}
